import { Skeleton, Stack } from "@mui/material";
import React from "react";

const ShippingInfoSkeleton = () => {
  return (
    <div className="shipping-info-content">
      <Stack spacing={1}>
        <div className="shipping-customer-name">
          <Skeleton width={"50%"} height={20} animation="wave" />
        </div>
        <div
          className="shipping-customer-contact-no"
          style={{ display: "flex" }}
        >
          Contact No{" "}
          <span style={{ width: "50%", marginLeft: "5px" }}>
            <Skeleton width={"100%"} height={20} animation="wave" />
          </span>
        </div>
        <div className="shipping-address">
          <div className="title-address">Address</div>
          <div className="address-content">
            <Skeleton width={"100%"} height={20} animation="wave" />
            <Skeleton width={"100%"} height={20} animation="wave" />
          </div>
        </div>
      </Stack>
    </div>
  );
};

export default ShippingInfoSkeleton;
